<template>
  <the-1-column-layout>
    <div style="float: right; margin-bottom: 20px">
      <span>{{this.loc('records')}}</span>
      <div class="custom-select__dropdown js-custom-select-dropdown" style="width: 80px; position: relative">
        <span class="custom-select__text js-custom-select-textholder">{{selectedValue}}</span>
        <select v-model="selected" @change="$refs.table.setLimit($event.target.value)" class="form__field-select js-custom-select form__field-select-custom js-lang-select lang_select">
          <option v-bind:text="10" value="10">10</option>
          <option v-bind:text="25" value="25">25</option>
        </select>
      </div>
    </div>
    <v-client-table ref="table" :columns="columns" :data="filteredData" :options="options">
      <router-link slot="name" slot-scope="props" :to="{ name: 'company', params: { id: props.row.id }}">{{props.row.name}}</router-link>
      <div slot="contacts" slot-scope="props">
        <div v-for="(contactName, index) in props.row.contacts" v-bind:key="index">
          {{contactName}}
        </div>
      </div>
    </v-client-table>
    <button class="btn btn--white" v-on:click="addCompany">{{loc('addCompany')}}</button>
    <modal-company ref="addCompanyModal" :modal-mode="'add'"></modal-company>
  </the-1-column-layout>
</template>

<script>

import ModalCompany from './modal-company.vue';

export default {
  components: {
    'modal-company': ModalCompany
  },
  data: function () {
    return {
      searchText: '',
      searchColumns: ['name', 'contacts', 'country'],
      columns: ['name', 'contacts', 'country'],
      sortable: ['name', 'contacts', 'country'],
      filterable: ['name', 'contacts', 'country'],
      selected: '10'
    }
  },
  computed: {

    options() {
      return {
        filterable: false,
        headings: {
          name: this.loc('name'),
          contacts: this.loc('contacts'),
          country: this.loc('country')
        },
        texts: {
            count: this.loc('paginationCount'),
            limit: this.loc('records'),
            noResults: this.loc('noMatchingResults'),
        }
      }
    },

    companyData() {
      const companies = [];
      this.$store.getters.childCompanies.forEach(company => {
        companies.push({
          name: company.name,
          id: company.id,
          contacts: company.users ? company.users.map(user => { return user.lastName + ', ' + user.firstName }) : [],
          country: company.country != null ? company.country.name : ''
        });
      });

      return companies;
    },

    filteredData() {
      const self = this;
      const searchText = this.$store.state.subheader.searchText; // Use subheader search input for searching
      const data = this.companyData;

      if(searchText) {
        const searchRegEx = new RegExp(searchText, 'i')

        return data.filter(function (item) {
          for(let i=0, l=self.searchColumns.length; i<l; i++) {
            const column = self.searchColumns[i];

            if(searchRegEx.test(item[column])) {
              return true;
            }
          }
          return false;
        });
      }
      return data;
    },
    selectedValue() {
      return this.selected;
    }
  },
  methods: {
    addCompany() {
      this.$refs.addCompanyModal.show();
    }
  },
  mounted: function () {
    this.$store.dispatch('getChildCompanies');

    this.$store.commit('setSubheader', {
      subtitle: '',
      title: this.loc('components.companies.subheaderTitle'),
      description: this.loc('components.companies.subheaderDescription'),
      searchEnabled: true
    });
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
